define( [
	"./fnToString"
], function( fnToString ) {
	"use strict";

	return fnToString.call( Object );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/ObjectFunctionString.js
// module id = 1824
// module chunks = 0